// src/LanguageSwitcher.js
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useOutsideClick from '../../hooks/useOutsideClick.ts'; // Importe notre nouveau hook
import './LanguageSwitcher.css';
const languages = {
  fr: { flag: '🇫🇷', name: 'Français' },
  en: { flag: '🇬🇧', name: 'English' },
  es: { flag: '🇪🇸', name: 'Español' },
  pt: { flag: '🇵🇹', name: 'Português' }
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Utilise le hook pour fermer le menu en cliquant à l'extérieur
  useOutsideClick(wrapperRef, () => setIsOpen(false));

  const handleLanguageSelect = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false); // Referme le menu après la sélection
  };

  const currentLanguage = languages[i18n.language] || languages.fr;
  // Filtre pour n'afficher que les autres langues dans les options
  const otherLanguages = Object.keys(languages).filter(code => code !== i18n.language);

  return (
    <div className="language-switcher-container" ref={wrapperRef}>
      {/* Le bouton principal qui affiche le drapeau actuel */}
      <button 
        className="language-selector-trigger" 
        onClick={() => setIsOpen(!isOpen)}
        title="Changer la langue"
      >
        {currentLanguage.flag}
      </button>

      {/* Conteneur pour les options qui s'affichent si 'isOpen' est true */}
      {isOpen && (
        <div className="language-options">
          {otherLanguages.map((code, index) => (
            <button
              key={code}
              className="language-option"
              onClick={() => handleLanguageSelect(code)}
              title={languages[code].name}
              // Astuce pour l'animation en arc de cercle via le style
              style={{ '--i': index, '--total': otherLanguages.length }}
            >
              {languages[code].flag}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;